import React, { useEffect, useState } from 'react';
import { Container } from 'components';
import Footer from 'components/footer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from 'services/api';
import { Form, Formik } from 'formik';
import ApplicationForm from 'pages/billings_plans/components/applicationForm';
import * as Yup from "yup";
import { RELATIONS } from 'services/api.config';
import moment from 'moment';
import { toast } from 'react-toastify';

const initialValues = {
  first_name: "",
  last_name: "",
  middle_name: "",
  email: "",
  phone_no: "",
  dob: "",
  sex: "",
  relation: "",
  nationality: "",
  aadhar_number: "",
  user_image: "",
};
const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .min(3, "Minimum 3 characters")
    .matches(/^[A-Za-z]+$/, "Only alphabets allowed"),
  middle_name: Yup.string()
    .matches(/^[A-Za-z]*$/, "Only alphabets allowed"),
  last_name: Yup.string()
    .matches(/^[A-Za-z]*$/, "Only alphabets allowed"),
  phone_no: Yup.string()
    .required("Phone number is required")
    .length(10, "Must be 10 digits")
    .matches(/^[0-9]+$/, "Only numbers allowed"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),
  dob: Yup.string().required("Date of Birth is required"),
  sex: Yup.string().required("Gender is required"),
  relation: Yup.string().required("Relation is required"),
  nationality: Yup.number().required("Nationality is required"),
  aadhar_number: Yup.string()
    .required("Aadhar Number is required")
    .matches(/^[0-9]{12}$/, "Must be exactly 12 digits"),
});

const EditMembership = () => {
  const navigate = useNavigate()
  const params = useParams();
  const [editMember, setEditMember] = useState({ ...initialValues });
  const [countries, setCountries] = useState([]);
  const [relations, setRelations] = useState([]);
  const [applicationId, setApplicationId] = useState(null);

  const handleEditMember = React.useCallback((data) => {
    const { first_name, last_name, middle_name, email, phone_no, dob, relation, sex, country_id, kyc_details } = data;

    const updatedValues = {
      first_name: first_name || "",
      last_name: last_name || "",
      middle_name: middle_name || "",
      email: email || "",
      phone_no: phone_no || "",
      dob: dob || "",
      sex: sex || "",
      relation: relation || "",
      nationality: country_id || "",
      aadhar_number: kyc_details?.aadhar_number || "",
      user_image: kyc_details?.user_image || "",
    };
    setEditMember(updatedValues)
  }, []);

  const fetchMembershipData = React.useCallback(async () => {
    try {
      const response = await api.get(`/membership-application?applicationNo=${params.id}`);
      const memberData = response?.data?.data?.memberApplication[0]
      if (memberData) {
        handleEditMember(memberData);
        setApplicationId(memberData.application_id);
      }
      console.log("Membership Data:", memberData);
    } catch (error) {
      console.error("Error fetching membership:", error);
    }
  }, [params.id, handleEditMember]);

  const countriesFetch = React.useCallback(async () => {
    try {
      const response = await api.get("/countries");
      const countriesList = response?.data?.data?.countries;
      setCountries(countriesList || []);
      console.log("countriesFetch:", countriesList);
    } catch (error) {
      console.log("countriesFetch:", error);
    }
  }, []);

  const fetchRelaction = React.useCallback(async () => {
    try {
      const response = await api.get(`${RELATIONS}`);
      const relationList = response?.data?.data?.relations;
      setRelations(relationList || []);
      console.log("relation fetch:", relationList);
    } catch (error) {
      console.log("relation fetch:", error);
    }
  }, []);
  const handleSubmit = async (formValues) => {
    try {
      const formattedValues = {
        ...formValues,
        dob: moment(formValues.dob).format("DD-MM-YYYY"),
      };

      const formData = new FormData();
      Object.keys(formattedValues).forEach((key) => {
        if (key === "user_image") {
          if (formattedValues[key] instanceof File) {
            formData.append(key, formattedValues[key]);
          }
        } else {
          formData.append(key, formattedValues[key]);
        }
      });

      const response = await api.post(`/membership-application-user/${applicationId}`, formData)
      console.log("handleSubmit:", response)
      if (response.status === 201) {
        navigate("/enrolledPlans")
        toast.success(response?.data?.message || "Added Succefully");
      }

      // https://api.zenosure.com/api/membership-application-user/{applicationId}
    } catch (error) {
      console.log("handleSubmit ERROR:", error)
      toast.error(error?.response?.data?.message || "Something went wrong");

    }
  }


  useEffect(() => {
    fetchMembershipData();
    countriesFetch();
    fetchRelaction();
  }, [fetchMembershipData, countriesFetch, fetchRelaction]);




  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/enrolledPlans">Plans</Link>
              </li>
              <li className="breadcrumb-item active">Edit membership details</li>
            </ol>
          </nav>
          <Formik
            initialValues={editMember}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={(values) => {
              console.log("Submitted data:", values);
              handleSubmit(values);
            }}
          >
            {({ values, setFieldValue, setValues, validateForm, setErrors }) => (
              <Form>
                <ApplicationForm
                  isDynamic={false}
                  values={values}
                  setValues={setValues}
                  setFieldValue={setFieldValue}
                  validateForm={validateForm}
                  setErrors={setErrors}
                  countries={countries}
                  relations={relations}
                />
                <div className="text-end mx-4">
                  <button type="submit" className="btn btn-success">
                    Update
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <Footer />
      </div>
    </Container>
  );
};

export default EditMembership;


